import React from "react";
import "./Styles/home.css"; // For custom styling
import LayOut from "../components/LayOut";
import Poster from "../../assets/poster.avif";
import { Link } from "react-router-dom";
import SkillPage from "./Skill";
import ClientCarousel from "./Client";

const HomePage = () => {
  return (
    <LayOut title={"Home Page"}>
      <div className="homepage">
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* Left Section */}
            <div className="col-md-6 text-section">
              <h1 className="heading">Hii here is Akash Dubey hire Me</h1>
              <p className="paragraph">
                Hello! I am Akash Dubey, a Full Stack Web Developer & Designer
                with a passion for creating interactive and animated websites. I
                bring experience in SEO optimization, cartoon and animation
                video creation, and a strong problem-solving mindset. My skills
                also include Adobe Photoshop, logo design, and file management
                expertise. Explore my projects to see my work in action!
              </p>
              <div className="button-section">
                <button className="btn custom-btn">
                  <a className="About" href="/Resume.pdf" download>
                    Download Resume
                  </a>
                </button>
              </div>
            </div>
            {/* Right Section */}
            <div className="col-md-6 threejs-section">
              <img src={Poster} alt="poster" />
            </div>
          </div>
        </div>
      </div>
      <SkillPage />
      {/* <ClientCarousel /> */}
    </LayOut>
  );
};

export default HomePage;
